import {Command} from "./Command";
import {EventManager} from "../event-manager";

class RemoveEventListenerCommand extends Command {

    execute(version: number, callback: Function, parameter?: number): void {
        if (!parameter) {
            callback(false);
        } else {
            const success = EventManager.unsubscribe(parameter);
            callback(success, success);
        }
    }
}

export {RemoveEventListenerCommand};
